import { Injectable } from '@angular/core';

import { FsMapGeometryServiceProvider } from '@lib/geo/core';
import { GoogleMap } from '@lib/geo/google/map';
import { FsMap } from '@lib/geo/map';

import { GoogleBoundsManagementService } from '../services/google/google-bounds-management.service';
import { GoogleGeometricNavigationService } from '../services/google/google-geometric-navigation.service';
import { GoogleZoomManagementService } from '../services/google/google-zoom-management.service';

@Injectable({
  providedIn: 'root',
})
export class GoogleMapGeometryProvider extends FsMapGeometryServiceProvider<GoogleMap> {
  constructor(
    private boundsService: GoogleBoundsManagementService,
    private zoomService: GoogleZoomManagementService,
    private navigationService: GoogleGeometricNavigationService,
  ) {
    super();
  }

  get geospatialProvider(): string {
    return 'google';
  }

  get id(): string {
    return 'google-map-geometry-provider';
  }

  get bounds() {
    return this.boundsService;
  }

  get zoom() {
    return this.zoomService;
  }

  get navigation() {
    return this.navigationService;
  }

  public setMap(map: GoogleMap) {
    this.boundsService.setMap(map);
    this.zoomService.setMap(map);
    this.navigationService.setMap(map);
  }
}
